import { useMutation } from '@tanstack/react-query';

import templateService from './templateService';

import type { ReviewTemplate } from '@/types/review/ReviewTemplate';

import { queryClient } from '@/AppWithProviders';
import { ReviewTemplateQueryKey } from '@/constants/QueryKeys';

export const useImportAmelioTemplate = () => {
    return useMutation<ReviewTemplate, Error, string>({
        mutationFn: (templateId) => templateService.importAmelioTemplate(templateId),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [ReviewTemplateQueryKey.TEMPLATE],
            });
        },
    });
};
